<template>
  <div id="orderFilter">
    <div class="flexer">
      <b-form-radio-group size="sm" class="pillbox" buttons button-variant="clear" v-model="status">
        <b-form-radio v-for="{status, shortStatus} in statuses" :value="status" :key="status">{{shortStatus}}</b-form-radio>
      </b-form-radio-group>

      <span class="status">
        <WaveSpinner inline v-if="recentOrdersBusy"/>
        <span v-else @click="reload">{{totalOrders}} orders</span>
      </span>


      <b-dropdown size="sm" variant="clear" right no-caret>
        <template slot="button-content"><i class="fas fa-ellipsis-v"/></template>
        <b-dropdown-item v-if="showAllStatuses" @click="showAllStatuses=false">Show key statuses</b-dropdown-item>
        <b-dropdown-item v-else @click="showAllStatuses=true">Show all statuses</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import {shortStatus, ALL_STATUSES, MAIN_STATUSES} from "@/lib/orderStatus"
import {mapGetters} from 'vuex';

export default {
  props: {
    statusInitial: { type: String, default: null },
  },
  data() {
    return {
      status: null,
      showAllStatuses: false,
    }
  },
  computed: {
    ...mapGetters(['totalOrders', 'recentOrdersBusy']),
    statuses() {
      const statuses = this.showAllStatuses ? ALL_STATUSES : MAIN_STATUSES;
      return [{status: null, shortStatus:'All'}].concat(statuses.map(status => ({status, shortStatus: shortStatus(status)})));
    },
  },
  watch: {
    status(val) {
      this.$emit('input', val);
    }
  },
  mounted() {
    this.status = this.statusInitial;
  },
  methods: {
    reload() {
      // Re-emit the input. this should hopefully reload...
      this.$emit('input', this.status);
    }
  }
}
</script>

<style lang="scss">
@import '~scss/colors';

#orderFilter {
  width: 100%;

  .flexer {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    padding-bottom: 1em;
  }

  .status {
    margin: 0 1em;
  }

  .pillbox {
    .btn-group > .btn-clear:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    .btn-group > .btn-clear:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    .btn-clear {
      border: 1px solid #ccc;
      padding: 8px 15px;
      height: auto;
      &.active {
        background: $gray-2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/orders/AdminOrderFilter.vue